import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-orgao',
  templateUrl: './dropdown-orgao.component.html',
  styleUrls: ['./dropdown-orgao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownOrgaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
